module.exports = __webpack_public_path__ + "img/rp.65a282b1.png";